import {
  Component,
  OnInit,
  ElementRef
} from '@angular/core';

import { D3Service } from '../../shared';

import * as d3 from 'd3';

@Component({
  selector: '[awair-x-axis]',
  templateUrl: './x-axis.component.html',
  styleUrls: ['./x-axis.component.scss']
})
export class XAxisComponent implements OnInit {

  constructor(
    private el: ElementRef,
    private d3Service: D3Service) { }

  ngOnInit() {
  }

  update(width: number, height: number, toDate: Date, xScale: any) {
    if (width !== null && height !== null && toDate && xScale) {
      const xAxis = this.d3Service.getAxisX(xScale, width, 12, -height);
      // xAxis
      //   .ticks(d3.timeHour.every(1))
      //   .tickFormat((d: any) => {
      //     if (!(d.getHours() % 2)) {
      //       return d.getHours();
      //     }
      //   });

      d3.select(this.el.nativeElement)
        .attr('class', 'x-axis')
        .attr('transform', 'translate(0,' + height + ')')
        .call(xAxis);

      d3.selectAll('.x-axis g.tick line')
        .attr('stroke-width', (d: any) => {
          return new Date(d).getTime() === toDate.getTime() ? '2px' : '1px';
        });
    }
  }
}
